import { PersonalAccessTokenSettingBeaconConfig } from '~src/authentication/components/PersonalAccessTokensSection';
import { AccessibilityPreferencesSettingBeaconConfig } from '~src/userSettings/components/AccessibilitySettings';
import { ChangePasswordSettingBeaconConfig } from '~src/userSettings/components/ChangePassword';
import {
  ConnectedClientsSettingBeaconConfig
} from '~src/userSettings/components/connected-clients/ConnectedClientsSection';
import { DataManagementAwarenessSettingBeaconConfig } from '~src/userSettings/components/DataManagementAwarenessSettings';
import {
  DisplayNameSettingBeaconConfig,
  EmailSettingBeaconConfig
} from '~src/userSettings/components/EmailAndDisplayNameForm';
import { UsernameSettingBeaconConfig } from '~src/userSettings/components/GeneralAuthSettings';
import {
  LanguageSettingBeaconConfig, RegionSettingBeaconConfig, TimeZoneSettingBeaconConfig
} from '~src/userSettings/components/LanguageAndRegionSettings';
import { AnimationSettingBeaconConfig } from '~src/userSettings/components/MarkAnimation';
import { NotificationPreferencesSettingBeaconConfig } from '~src/userSettings/components/NotificationsSettings';
import { SavedCredentialSettingBeaconConfig } from '~src/userSettings/components/SavedCredentialsForDataSourceSetting';
import { StartPageSettingBeaconConfig } from '~src/userSettings/components/StartPageSetting';
import { DataAlertSettingBeaconConfig } from '~src/userSettings/components/SuspendedDataAlertSetting';
import { SubscriptionsSettingBeaconConfig } from '~src/userSettings/components/SuspendedSubscriptionSetting';
import { ToastAutoDismissSettingBeaconConfig } from '~src/userSettings/components/ToastAutoDismissSetting';
import { ViewerControlledThemeSettingBeaconConfig } from '~src/userSettings/components/ViewerControlledThemeSetting';
import { WelcomeBannerSettingBeaconConfig } from '~src/userSettings/components/WelcomeBanner';

import { BeaconComponentConfig } from './BeaconComponentRegistryFunctions';


export function createBeaconComponentRegistry(...specArray: BeaconComponentConfig[]) {
  return specArray;
}

let beaconRegistry: BeaconComponentConfig[] = undefined;

/**
 * All react-based sections in the settings page should be added to this object to allow them to be beacon components
 */
export function getBeaconComponentRegistry() {
  if (!beaconRegistry) {
    beaconRegistry =  createBeaconComponentRegistry(
                          UsernameSettingBeaconConfig,
                          DisplayNameSettingBeaconConfig,
                          EmailSettingBeaconConfig,
                          ChangePasswordSettingBeaconConfig,
                          SavedCredentialSettingBeaconConfig,
                          ConnectedClientsSettingBeaconConfig,
                          PersonalAccessTokenSettingBeaconConfig,
                          NotificationPreferencesSettingBeaconConfig,
                          SubscriptionsSettingBeaconConfig,
                          DataAlertSettingBeaconConfig,
                          StartPageSettingBeaconConfig,
                          WelcomeBannerSettingBeaconConfig,
                          AnimationSettingBeaconConfig,
                          DataManagementAwarenessSettingBeaconConfig,
                          LanguageSettingBeaconConfig,
                          RegionSettingBeaconConfig,
                          TimeZoneSettingBeaconConfig,
                          AccessibilityPreferencesSettingBeaconConfig,
                          ToastAutoDismissSettingBeaconConfig,
                          ViewerControlledThemeSettingBeaconConfig,
                        );
  }

  return beaconRegistry;
}

/**
 * function to manually clear out a previously instantiated registry.
 * exposed for testing
 */
export function flushBeaconComponentRegistry() {
  beaconRegistry = undefined;
}
